import {
    GET_HOME_VIDEO,
    VI_LOADING,
    UPDATE_HOME_VIDEO,
    UPDATE_RAFT_VIDEO,
    GET_RAFT_VIDEO,
} from "../actions/VideoHomeActions"

const initialState = {
    video: [],
    videoRaft: [],
    menuitem: [],
    loading: true,
    success: true,
    addVideo: null
};

const VideoReducer = function(state = initialState, action){
    switch (action.type) {
        case VI_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case GET_HOME_VIDEO: {
            return {
                ...state,
                video: [action.data],
                loading: false
            }
        }
        case GET_RAFT_VIDEO: {
            return {
                ...state,
                videoRaft: [action.data],
                loading: false
            }
        }
        case UPDATE_HOME_VIDEO: {
            return {
                ...state,
                addVideo : action.data,
                success: true,
                loading: false
            }
        }
        case UPDATE_RAFT_VIDEO: {
            return {
                ...state,
                addVideo : action.data,
                success: true,
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default VideoReducer;
